export const EMPLOYEE_NOTIFICATION_DISMISS_PAYLOAD: Record<App.BusinessTraveller.SocieteNotificationType, App.BusinessTraveller.UpdateEmployeeNotificationInput> = {
  'UNLOCK': { societe: { unlockTierDismissed: true } },
  'ALMOST_THERE': { societe: { almostThereDismissed: true } },
  'COMPLETION': { societe: { completionDismissed: true } },
}
